/**
 * Получение значения cookie
 * @param key Ключ
 */
export function getCookie(key: string): string {
  const cookies = document.cookie.split(";");
  let cookieRes;
  const cookieArr = cookies.filter((c: any) => {
    return key === c.split("=")[0].trim();
  });
  if (cookieArr.length > 0) {
	  cookieRes = cookieArr.find((c: any) => {
	    return c.split("=")[1] && c.split("=")[1].trim() !== '';
	  });
  }
  return cookieRes ? cookieRes.split("=")[1] : "";
}

/**
 *
 * @param key Ключ
 * @param value Значение
 */
export function setCookie(key: string, value: string, path: string = undefined) {
  let result = `${key}=${value}`;
  if (path)
  	result += "path=" + path + "; ";
  document.cookie = result;
}
